import { Injectable } from '@angular/core';
import { Resources } from 'app/models2/maintenance/resources';
import { ResourcesBulk } from 'app/models2/maintenance/resources-bulk';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { HttpService, MessageService } from 'brainloper-ui';
import { InputOrOutputInventory } from 'app/models2/inventory/input-or-output-inventory';
import { Item } from 'app/models2/inventory/item';
import { UpdateData } from 'app/models2/commos/update-data';
import { GenericResponse } from 'app/models2/commos/generic-response';

@Injectable({
  providedIn: 'root'
})
export class ResourcesService {

  private urlGetCrudResourcesOT: string = `${EndpointDictionary.Resources.CRUD_RESOURCES_DATA}`
  private urlGetCrudResourcesR: string = `${EndpointDictionary.ResourcesRequest.CRUD_RESOURCES_REQUEST_DATA}`

  constructor(
    private message: MessageService,
    private http: HttpService,
  ) { }


  async saveResources($event:Array<InputOrOutputInventory>, associatedId:number, isResourceOT:boolean) {

    if(!$event || $event.length == 0 )
      return

    let items:Array<Item> = []
    $event.forEach(item => {
      items.push({
        id:item.itemInventoryId,
        amount:item.amount,
        costItem:item.costItem
      })
    });

    let body: ResourcesBulk =  {
      orderId: associatedId,
      requestId : associatedId,
      items: items
    }

    let res = await this.http.postDataBody<GenericResponse>(isResourceOT?this.urlGetCrudResourcesOT:this.urlGetCrudResourcesR, body)
    if (!res) {
      this.message.ErrorToast("Error guardado recursos")
    }
  }

  async addResourcesFromTable($event:Resources, associatedId:number, isResourceOT:boolean){
    let body: ResourcesBulk = {
      orderId: associatedId,
      requestId : associatedId,
      items: [{
        id: $event.itemId,
        amount: $event.amount,
        costItem: $event.itemNameCombo?.costItem,
      }]
    }

    if(body.items.find(x => !x.id || !x.amount || x.id.toString() == '' || x.amount.toString() == '' || x.amount.toString() == '0')){
      if(body.items[0].amount <= 0){
        this.messageValidateAmout()
      }
      return
     }

   this.message.openLoading('Guardando', 'Agregando recurso')

   let res = await this.http.postDataBody<GenericResponse>(isResourceOT?this.urlGetCrudResourcesOT:this.urlGetCrudResourcesR, body)
   if (!res) {
     this.message.ErrorToast("Error agregando recurso")
    }

    this.message.closeLoading()
   }

   async editResourcesFromTable($event: UpdateData<Resources>, associatedId:number, isResourceOT:boolean){
     let body: Resources = {
      orderId: associatedId,
      requestId: associatedId,
      itemInventoryId: $event.old.itemInventoryId,
      amount: $event.new.amount,
      id: $event.old.id
    }

    if(body.amount <= 0){
      this.messageValidateAmout()
      return
    }

    this.message.openLoading('Guardando', 'Editando recurso')

    let res = await this.http.putDataBody<GenericResponse>(isResourceOT?this.urlGetCrudResourcesOT:this.urlGetCrudResourcesR, body)
    if (!res) {
      this.message.ErrorToast("Error editando recurso")
    }

    this.message.closeLoading()
   }

   private messageValidateAmout(){
    this.message.Error('Error', 'La cantidad debe ser mayor a 0')
  }
}
